import {
  errorMetaData,
  pendingMetaData,
  resetMetaData,
  successMetaData,
} from "@workspace/common";
import {
  CHANGE_PREOFFER_STATUS,
  CHANGE_PREOFFER_STATUS_FAILURE,
  CHANGE_PREOFFER_STATUS_RESET,
  CHANGE_PREOFFER_STATUS_SUCCESS,
  FETCH_BGC_COUNTS,
  FETCH_BGC_COUNTS_FAILURE,
  FETCH_BGC_COUNTS_SUCCESS,
  FETCH_PREOFFER_CANDIDATES,
  FETCH_PREOFFER_CANDIDATES_FAILURE,
  FETCH_PREOFFER_CANDIDATES_SUCCESS,
  FETCH_PREOFFER_COUNTS,
  FETCH_PREOFFER_COUNTS_FAILURE,
  FETCH_PREOFFER_COUNTS_SUCCESS,
  FETCH_SLA_COUNTS,
  FETCH_SLA_COUNTS_FAILURE,
  FETCH_SLA_COUNTS_SUCCESS,
  OFFER_STATUS,
  OFFER_STATUS_FAILURE,
  OFFER_STATUS_RESET,
  OFFER_STATUS_SUCCESS,
  OFFER_STATUS_WITH_ATTACHMENT,
  OFFER_STATUS_WITH_ATTACHMENT_FAILURE,
  OFFER_STATUS_WITH_ATTACHMENT_RESET,
  OFFER_STATUS_WITH_ATTACHMENT_SUCCESS,
} from "./actionTypes";

const initialState = {
  candidateMeta: {},
  candidates: [],
  countsMeta: {},
  counts: null,
  bgcCountsMeta: {},
  bgcCounts: null,
  slaCountsMeta: {},
  slaCounts: null,
  changeStatusMeta: {},
  changeStatus: null,
  offerStatusMeta: {},
  offerStatus: null,
};

const PreOfferCandidateReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch all candidates
    case FETCH_PREOFFER_CANDIDATES:
      return {
        ...state,
        candidateMeta: pendingMetaData(),
      };
    case FETCH_PREOFFER_CANDIDATES_SUCCESS:
      return {
        ...state,
        candidateMeta: successMetaData(action.payload),
        candidates: action.payload,
      };
    case FETCH_PREOFFER_CANDIDATES_FAILURE:
      return {
        ...state,
        candidates: [],
        candidateMeta: errorMetaData(action.payload),
      };

    // Fetch all counts
    case FETCH_PREOFFER_COUNTS:
      return {
        ...state,
        countsMeta: pendingMetaData(),
      };
    case FETCH_PREOFFER_COUNTS_SUCCESS:
      return {
        ...state,
        countsMeta: successMetaData(action.payload),
        counts: action.payload,
      };
    case FETCH_PREOFFER_COUNTS_FAILURE:
      return {
        ...state,
        chan: null,
        countsMeta: errorMetaData(action.payload),
      };

    // Fetch SLA counts
    case FETCH_SLA_COUNTS:
      return {
        ...state,
        slaCountsMeta: pendingMetaData(),
      };
    case FETCH_SLA_COUNTS_SUCCESS:
      return {
        ...state,
        slaCountsMeta: successMetaData(action.payload),
        slaCounts: action.payload,
      };
    case FETCH_SLA_COUNTS_FAILURE:
      return {
        ...state,
        slaCounts: null,
        slaCountsMeta: errorMetaData(action.payload),
      };

    // Fetch BGC counts
    case FETCH_BGC_COUNTS:
      return {
        ...state,
        bgcCountsMeta: pendingMetaData(),
      };
    case FETCH_BGC_COUNTS_SUCCESS:
      return {
        ...state,
        bgcCountsMeta: successMetaData(action.payload),
        bgcCounts: action.payload,
      };
    case FETCH_BGC_COUNTS_FAILURE:
      return {
        ...state,
        bgcCounts: null,
        bgcCountsMeta: errorMetaData(action.payload),
      };

    // Change Status counts
    case CHANGE_PREOFFER_STATUS:
      return {
        ...state,
        changeStatusMeta: pendingMetaData(),
      };
    case CHANGE_PREOFFER_STATUS_SUCCESS:
      return {
        ...state,
        changeStatusMeta: successMetaData(action.payload),
        changeStatus: action.payload,
      };
    case CHANGE_PREOFFER_STATUS_FAILURE:
      return {
        ...state,
        changeStatus: null,
        changeStatusMeta: errorMetaData(action.payload),
      };
    case CHANGE_PREOFFER_STATUS_RESET:
      return {
        ...state,
        changeStatus: null,
        changeStatusMeta: resetMetaData(),
      };

    // Offer Status
    case OFFER_STATUS:
      return {
        ...state,
        offerStatusMeta: pendingMetaData(),
      };
    case OFFER_STATUS_SUCCESS:
      return {
        ...state,
        offerStatusMeta: successMetaData(action.payload),
        offerStatus: action.payload,
      };
    case OFFER_STATUS_FAILURE:
      return {
        ...state,
        offerStatus: null,
        offerStatusMeta: errorMetaData(action.payload),
      };
    case OFFER_STATUS_RESET:
      return {
        ...state,
        offerStatus: null,
        offerStatusMeta: resetMetaData(),
      };

    // Offer Status with attachment
    case OFFER_STATUS_WITH_ATTACHMENT:
      return {
        ...state,
        offerStatusMeta: pendingMetaData(),
      };
    case OFFER_STATUS_WITH_ATTACHMENT_SUCCESS:
      return {
        ...state,
        offerStatusMeta: successMetaData(action.payload),
        offerStatus: action.payload,
      };
    case OFFER_STATUS_WITH_ATTACHMENT_FAILURE:
      return {
        ...state,
        offerStatus: null,
        offerStatusMeta: errorMetaData(action.payload),
      };
    case OFFER_STATUS_WITH_ATTACHMENT_RESET:
      return {
        ...state,
        offerStatus: null,
        offerStatusMeta: resetMetaData(),
      };
    default:
      return state;
  }
};

export default PreOfferCandidateReducer;
